export interface JobMetadataResponse {
    category: string
    value: string
    description: string
}

// eslint-disable-next-line no-magic-numbers
export const JOB_LEVELS = [1, 2, 3, 4, 5, 6, 7, 8, 9]
// Source of truth for the enums below is JobObjectsModel's Requisition enumerations:
// https://code.amazon.com/packages/JobObjectsModel/blobs/mainline/--/model/objects/Requisition/enumerations.smithy
//
// Each @enum member has a `name` and a `value`. `name` is only a Smithy-local identifier; the
// generated SDKs and the wire format use `value`, uppercased with non-alphanumeric runs collapsed
// to '_'. This list originally took `name`, which is why the values below drifted from the wire.
// Derive `value` from the model's `value` field, and `description` from it as-is, e.g.
//   { value: "Backfill Ahead Of Attrition", name: "BACKFILL_AHEAD" } -> 'BACKFILL_AHEAD_OF_ATTRITION'
export const HIRE_TYPES: JobMetadataResponse[] = [
    {
        category: 'JOB_HIRE_TYPE_ID',
        value: 'ACQUISITION',
        description: 'Acquisition',
    },
    {
        category: 'JOB_HIRE_TYPE_ID',
        value: 'BACKFILL_AHEAD_OF_ATTRITION',
        description: 'Backfill Ahead Of Attrition',
    },
    {
        category: 'JOB_HIRE_TYPE_ID',
        value: 'BACKFILL_FOR_KNOWN_EMPLOYEE',
        description: 'Backfill For Known Employee',
    },
    {
        // 'CAMPUE' is a typo in the model's `value` ("Campue Fte"), not here — the `name` for this
        // member is the correctly spelled CAMPUS_FTE, but `name` is not what goes on the wire. Keep
        // it misspelled until the upstream model is fixed. The description stays spelled correctly
        // because it is display-only and never sent.
        category: 'JOB_HIRE_TYPE_ID',
        value: 'CAMPUE_FTE',
        description: 'Campus Fte',
    },
    {
        category: 'JOB_HIRE_TYPE_ID',
        value: 'CAMPUS_INTERN',
        description: 'Campus Intern',
    },
    {
        category: 'JOB_HIRE_TYPE_ID',
        value: 'EXPLORATORY',
        description: 'Exploratory',
    },
    {
        category: 'JOB_HIRE_TYPE_ID',
        value: 'NEW_POSITION',
        description: 'New Position',
    },
]

export const ROLE_KINDS: JobMetadataResponse[] = [
    {
        category: 'JOB_ROLE_KIND',
        value: 'INDIVIDUAL_CONTRIBUTOR',
        description: 'Individual Contributor',
    },
    {
        category: 'JOB_ROLE_KIND',
        value: 'PEOPLE_MANAGER',
        description: 'People Manager',
    },
]

// Same source of truth and same name-vs-value rule as HIRE_TYPES above.
export const BUSINESS_PURPOSES: JobMetadataResponse[] = [
    {
        // Model member is { value: "AWS - Early Career Talent", name: "AWS_ECT" }. The wire value
        // derives from `value`, so it is AWS_EARLY_CAREER_TALENT — AWS_ECT is the `name` only.
        category: 'JOB_BUSINESS_PURPOSE',
        value: 'AWS_EARLY_CAREER_TALENT',
        description: 'AWS - Early Career Talent',
    },
    {
        category: 'JOB_BUSINESS_PURPOSE',
        value: 'OPS_UNIVERSITY',
        description: 'Ops University',
    },
    {
        category: 'JOB_BUSINESS_PURPOSE',
        value: 'OTHER',
        description: 'Other',
    },
    {
        category: 'JOB_BUSINESS_PURPOSE',
        value: 'STUDENT_PROGRAMS',
        description: 'Student Programs',
    },
]
